"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var load_script_1 = require("./load-script");
var GA = (function (window, document) {
    var initialized = false;
    // We can use promises because we have the promise polyfill
    // loaded.
    var init = function () { return new Promise(function (resolve, reject) {
        if (initialized) {
            return resolve();
        }
        if (process.env.MIX_APP_ENV === 'production') {
            // Setup the data layer and gtag function.
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                window.dataLayer.push(arguments);
            };
            // Add some initial gtag values.
            window.gtag('consent', 'default', {
                'analytics_storage': 'denied'
            });
            window.gtag('js', new Date());
            window.gtag('config', window.clubadminpro_page_data.GA_TRACKING_ID);
            // Import the script to the document.
            var scriptSrc = 'https://www.googletagmanager.com/gtag/js?id=' + window.clubadminpro_page_data.GA_TRACKING_ID;
            (0, load_script_1.loadScript)(scriptSrc).then(function () {
                // Initialized;
                initialized = true;
                // Resolve.
                resolve();
            }).catch(function (err) {
                //
            });
        }
        else {
            // Initialized;
            initialized = true;
        }
    }); };
    var enable = function () {
        if (!initialized || process.env.MIX_APP_ENV !== 'production') {
            return;
        }
        window.gtag('consent', 'update', {
            'analytics_storage': 'granted'
        });
    };
    var disable = function () {
        if (!initialized || process.env.MIX_APP_ENV !== 'production') {
            return;
        }
        window.gtag('consent', 'update', {
            'analytics_storage': 'denied'
        });
    };
    return {
        init: init,
        enable: enable,
        disable: disable
    };
})(window, document);
module.exports = GA;
